import { Expense } from "@finway-group/shared/lib/models"
import { checkIsNegativeValueForbidden } from "@finway-group/shared/lib/utils/expense.utils"
import { FormInstance, Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"
import { CompanyService } from "~Shared/services"
import { doAllElementsHaveTheSameFieldValue } from "~Shared/utils/helper.utils"
import { checkIsExpenseAccountMandatoryForExpenseStatus, isFolderExpense } from "../../../shared/utils/expense.utils"

export const nonNegativeBasedOnStatusAndKind = ({ formInstance, isZeroAllowed }: { formInstance?: FormInstance; isZeroAllowed: boolean }): Rule => ({
    validator: (_rule, inputValue: string) => {
        const resolvedValue = inputValue ? inputValue.toString() : ""
        if (checkIsNegativeValueForbidden(formInstance?.getFieldValue("status"), formInstance?.getFieldValue("kind"))) {
            if ((isZeroAllowed && Number(resolvedValue) < 0) || (!isZeroAllowed && Number(resolvedValue) <= 0)) {
                return Promise.reject(new Error(i18n.t("validation:greater.number_short", { min: 0 })))
            }
        }

        return Promise.resolve()
    },
})

export const costCenterRules = (): Array<Rule> => [
    {
        required: true,
        validator: (_rule, value) => {
            if (!value) {
                return Promise.reject(new Error(i18n.t("validation:required")))
            }

            return Promise.resolve()
        },
    },
]

export const getExpenseAccountRules = (expense: Expense): Array<Rule> => {
    const isExpenseAccountMandatory =
        expense &&
        checkIsExpenseAccountMandatoryForExpenseStatus({
            expenseStatus: expense?.status,
            isExpenseAccountMandatory: CompanyService.doesCompanyEnforceGobdCompliantInvoice(),
            isFolder: isFolderExpense(expense),
        })
    return [
        {
            required: isExpenseAccountMandatory,
            validator: (_rule, value: string) => {
                if (!isExpenseAccountMandatory) {
                    return Promise.resolve()
                }
                if (value) {
                    return Promise.resolve()
                }

                // Only allow empty expense account if the splits has different expense accounts assigned.
                if (!expense?.splits || expense.splits.length <= 1) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                const isSplitExpenseAccountUniform = doAllElementsHaveTheSameFieldValue(
                    expense.splits.map((s) => s.expenseAccount),
                    "_id",
                )

                if (isSplitExpenseAccountUniform) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                return Promise.resolve()
            },
        },
    ]
}
